/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';

import { ApiModule as ApiAuthModule } from "app/openapi-auth/api.module";
import { ApiModule as ApiHqModule } from "app/openapi-hq/api.module";
import { AuthService } from 'app/modules/auth/services/auth.service';
import { JwtInterceptor } from 'app/modules/auth/JwtInterceptor';
import { WithCredentialsInterceptor } from './modules/auth/WithCredentialsInterceptor';
import { APIKeyInterceptor } from './modules/auth/APIKeyInterceptor';
import { ReactiveFormsModule } from '@angular/forms';
import { ProductsModule } from './modules/products/products.module';
import { PartnersModule } from './modules/partners/partners.module';
import { LicensesModule } from './modules/licenses/licenses.module';
import { LicensePackagesModule } from './modules/license-packages/license-packages.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot({
      duration: 5000,
    }),
    NbDialogModule.forRoot(),
    /*NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),*/
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    ApiAuthModule,
    ApiHqModule,
    ProductsModule,
    PartnersModule,    
  ],
  bootstrap: [AppComponent],
  providers: [    
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: WithCredentialsInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: APIKeyInterceptor, multi: true },    
    NbDialogService
  ]
})
export class AppModule {
}
